<template>
  <div class="questionnaire-container questionnaire-date-range row visible-on col-sm-7 col-sm-offset-3 col-md-8 col-lg-4 col-md-offset-1 col-lg-offset-4">
    <span ref="form-label" :class="['col-xs-11 form-label text-left', 'col-sm-5 col-md-10 col-lg-10', fixStyle]">{{ label }}</span>
    <div :class="['date-range-body col-xs-12 col-sm-5 col-md-7 col-lg-12', internalErrorMessage ? 'error-border' : '']">
      <div class="month-field month-field--start">
        <el-date-picker
          :disabled="isDisabled"
          :clearable="false"
          :value="internalValue.start"
          type="month"
          value-format="yyyy-MM"
          format="yyyy-MM"
          popper-class="questionnaire-month-picker"
          :placeholder="placeholder"
          @input="onStartChange"
        />
      </div>
      <span class="range-separator">-</span>
      <div class="month-field month-field--end">
        <el-date-picker
          :disabled="isDisabled"
          :value="internalValue.end"
          type="month"
          value-format="yyyy-MM"
          format="yyyy-MM"
          popper-class="questionnaire-month-picker"
          :placeholder="placeholder"
          @input="onEndChange"
        />
      </div>
    </div>
    <div v-if="internalErrorMessage" class="col-xs-12 col-sm-7 col-md-7 col-lg-12 error-text">{{ internalErrorMessage }}</div>
  </div>
</template>

<script>
import { questionnaireMixin } from './mixin.js'

export default {
  mixins: [questionnaireMixin],
  props: {
    label: { type: String, default: '' },
    isEditable: { type: String, default: '' },
    value: { type: [String, Object], default: '' },
    placeholder: { type: String, default: '' },
    isRequired: { type: [String, Boolean], default: false },
    config: { type: Object, default: null }
  },
  data () {
    return {
      isDisabled: this.isEditable === 'false',
      internalValue: {
        start: '',
        end: null
      },
      internalErrorMessage: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    this.internalValue = this.normalizeValue(this.value)
  },
  watch: {
    value: {
      handler (val) {
        this.internalValue = this.normalizeValue(val)
      },
      immediate: true
    },
    internalValue: {
      handler (val) {
        this.$emit('change', JSON.stringify(val))
      },
      deep: true
    },
    '$i18n.locale' () {
      this.validate()
    }
  },
  methods: {
    normalizeValue (value) {
      if (!value) {
        return { start: '', end: null }
      }
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value)
        } catch (e) {
          value = {}
        }
      }
      return {
        start: value.start || '',
        end: value.end || null
      }
    },
    onStartChange (value) {
      this.internalValue.start = value || ''
      this.internalErrorMessage = ''
    },
    onEndChange (value) {
      if (!value) {
        this.internalValue = { start: '', end: null }
      } else {
        this.internalValue.end = value
      }
      this.internalErrorMessage = ''
    },
    validate () {
      if (this.fieldIsRequired(this.isRequired) && !this.internalValue.start) {
        this.internalErrorMessage = this.isRequiredMessage
        return false
      }
      this.internalErrorMessage = ''
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/questionnaire-common.scss';

.questionnaire-date-range {
  margin-bottom: 1.2rem;

  .text-left {
    justify-content: flex-start;
  }

  .date-range-body {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    min-height: 42px;
    padding: 0;
  }

  .month-field {
    flex: 1 1 0;
    min-width: 0;
    height: 40px;
    display: inline-flex;
    align-items: center;
    padding: 0;

    ::v-deep .el-date-editor.el-input {
      width: 100%;
    }

    ::v-deep .el-input__inner {
      height: 40px;
      line-height: 40px;
      border: 0;
      border-radius: 0;
      font-size: 16px;
    }
  }

  .month-field--start ::v-deep .el-input__inner {
    padding-left: 52px;
    padding-right: 0;
  }

  .month-field--end {
    ::v-deep .el-input__prefix {
      display: none;
    }

    ::v-deep .el-input__inner {
      padding-left: 24px;
      padding-right: 28px;
    }
  }

  .range-separator {
    display: inline-flex;
    flex: 0 0 48px;
    justify-content: center;
    color: #303133;
    font-size: 16px;
  }

  .error-border {
    border-color: red;
  }
}
</style>

<style lang="scss">
.questionnaire-month-picker {
  &.el-date-picker {
    font-size: 13px;

    .el-date-picker__header-label {
      font-size: 14px;
    }

    .el-month-table {
      font-size: 13px;
    }

    .el-month-table td .cell {
      font-size: 13px;
    }
  }
}
</style>
